import {
  Spinner,
  Text,
  Grid,
  Stack,
  Input,
  Center,
  InputGroup,
  InputRightElement,
  Box,
  GridItem,
  Select,
  Button,
  InputLeftAddon,
} from "@chakra-ui/react";
import EventBox from "../Components/EventBox";
import { getEvents, getProductType } from "../apis/library.api";
import { useEffect, useState } from "react";
import CloseIcon from "../assets/images/icons/Close filter.svg";
import SearchIcon from "../assets/images/icons/Search icon.svg";
import ArrowIcon from "../assets/images/icons/Icon-Medium-Grey-Arrow-right.svg";
import { useMediaQuery } from "react-responsive";
import { LibraryProductTypes } from "../assets/constants";

// All event data array.
var allEventData = [];

export default function Content(productType = null) {
  const [isLoading, setIsLoading] = useState(true);
  const [showSmallPageFilters, setShowSmallPageFilters] = useState(false);

  // Filter menu state values
  const [locationStateValue, setLocationStateValue] = useState("");
  const [fromStateValue, setFromStateValue] = useState("");
  const [toStateValue, setToStateValue] = useState("");
  const [searchStateValue, setSearchStateValue] = useState("");

  const [filteredEvents, setFilteredEvents] = useState([]);
  const [pageItems, setPageItems] = useState([]);
  const [pageLength] = useState(8);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    const newPageItems = filteredEvents.slice(
      pageLength * pageIndex,
      pageLength * (pageIndex + 1)
    );
    const newPageCount = Math.ceil(filteredEvents.length / pageLength) || 1;

    setPageCount(newPageCount);
    setPageItems(newPageItems);
  }, [pageIndex, pageLength, filteredEvents]);

  // Define size for tablets or smaller
  const isTabletOrSmaller = useMediaQuery({
    query: "(max-width: 800px)",
  });

  const productTypeValue = productType;

  useEffect(() => {
    const runGetEvents = async () => {
      const response = await getEvents(productTypeValue);

      for (var item in response) {
        // Check events are future or today and add to the all event list.
        var dateCheck = new Date();
        dateCheck.setDate(dateCheck.getDate() - 1);

        if (response[item].date >= dateCheck) {
          // Set Product Type for each event
          var productTypes = [];

          // Loop through product types and get product names from API
          for (const index in response[item].productTypeId) {
            var productType = await getProductType(
              response[item].productTypeId[index]
            );
            if (LibraryProductTypes.indexOf(productType) > -1) {
              productTypes.push(productType);
            }
          }

          response[item].productTypeName = productTypes;

          allEventData.push(response[item]);
        }
      }

      // Sort the event data from most recent first
      allEventData = []
        .concat(allEventData)
        .sort((a, b) => (a.date > b.date ? 1 : -1));

      setFilteredEvents(allEventData);
      setIsLoading(false);
    };

    // Run Events or stop loading
    if (allEventData.length === 0) {
      runGetEvents();
    } else {
      if (isLoading === true) {
        setIsLoading(false);
      }
    }

    // eslint-disable-next-line
  }, []);

  // Filter everything when selected
  function PageFilters() {
    let fromValue: any = (
      document.getElementById("fromDate") as HTMLInputElement
    ).value;
    let toValue: any = (document.getElementById("toDate") as HTMLInputElement)
      .value;
    let searchValue: any = (
      document.getElementById("search") as HTMLInputElement
    ).value;
    let locationValue: any = (
      document.getElementById("location") as HTMLInputElement
    ).value;

    if (fromValue) {
      setFromStateValue(fromValue);
      fromValue = new Date(fromValue);
      fromValue = fromValue.setHours(0, 0, 0, 0);
      fromValue = new Date(fromValue);
    }

    if (toValue) {
      setToStateValue(toValue);
      toValue = new Date(toValue);
      toValue = toValue.setHours(23, 59, 59, 0);
      toValue = new Date(toValue);
    }

    var filters = {
      fromFilter: (item) => item.date >= fromValue,
      toFilter: (item) => item.date <= toValue,
      searchValue: (item) =>
        item.title.toLowerCase().includes(searchValue.toLowerCase()),
      locationValue: (item) => item.city === locationValue,
    };

    var selectedFilters = [];

    if (fromValue) {
      selectedFilters.push(filters.fromFilter);
    }

    if (toValue) {
      selectedFilters.push(filters.toFilter);
    }

    if (searchValue) {
      selectedFilters.push(filters.searchValue);
      setSearchStateValue(searchValue);
    }

    if (locationValue) {
      selectedFilters.push(filters.locationValue);
      setLocationStateValue(locationValue);
    }

    setPageIndex(0);
    setFilteredEvents(
      allEventData.filter((item) => selectedFilters.every((f) => f(item)))
    );
  }

  // Clear all filters
  function ClearFilters() {
    var fromValue: any = document.getElementById(
      "fromDate"
    ) as HTMLInputElement;
    var toValue: any = document.getElementById("toDate") as HTMLInputElement;
    let searchValue: any = document.getElementById(
      "search"
    ) as HTMLInputElement;
    let locationValue: any = document.getElementById(
      "location"
    ) as HTMLInputElement;

    fromValue.value = "";
    toValue.value = "";
    searchValue.value = "";
    locationValue.value = "";

    setFromStateValue("");
    setToStateValue("");
    setLocationStateValue("");
    setSearchStateValue("");

    PageFilters();
  }

  function incrementPage() {
    setPageIndex(pageIndex + 1);
  }

  function decrementPage() {
    setPageIndex(pageIndex - 1);
  }

  return (
    <>
      {isLoading && (
        <Center>
          <Text textStyle="body-regular">
            Loading... <Spinner ml="10px" />
          </Text>
        </Center>
      )}
      {!isLoading && (
        <Stack spacing="24px" p="20px">
          <Stack spacing="24px">
            {/* FILTER MENU */}
            {isTabletOrSmaller && (
              <Box>
                <Button
                  textStyle="body-label"
                  w="100%"
                  onClick={() => setShowSmallPageFilters(!showSmallPageFilters)}
                >
                  {showSmallPageFilters ? "Hide" : "Show"} Filters
                </Button>
              </Box>
            )}
            {(!isTabletOrSmaller ||
              (isTabletOrSmaller && showSmallPageFilters)) && (
              <Stack
                spacing="24px"
                direction={isTabletOrSmaller ? "column" : "row"}
                className="filter-menu"
              >
                {/* Input group for search term */}
                <Select
                  variant="subtle"
                  id="location"
                  textStyle="body-label"
                  onChange={() => PageFilters()}
                  defaultValue={locationStateValue}
                >
                  <option value="">All locations</option>
                  <option value="Maitland">Maitland</option>
                  <option value="East Maitland">East Maitland</option>
                  <option value="Rutherford">Rutherford</option>
                  <option value="Thornton">Thornton</option>
                </Select>
                {/* Change how dates work with Page Size */}
                {isTabletOrSmaller ? (
                  <>
                    <Stack direction="column" gap="0">
                      <InputGroup>
                        <InputLeftAddon textStyle="body-label">
                          From
                        </InputLeftAddon>
                        <Input
                          variant="subtle"
                          id="fromDate"
                          textStyle="body-label"
                          type="date"
                          defaultValue={fromStateValue}
                          onChange={() => PageFilters()}
                        />
                      </InputGroup>
                    </Stack>

                    <Stack gap="0">
                      <InputGroup>
                        <InputLeftAddon textStyle="body-label">
                          To
                        </InputLeftAddon>
                        <Input
                          variant="subtle"
                          id="toDate"
                          textStyle="body-label"
                          type="date"
                          defaultValue={toStateValue}
                          onChange={() => PageFilters()}
                        />
                      </InputGroup>
                    </Stack>
                  </>
                ) : (
                  <>
                    <InputGroup>
                      <InputLeftAddon textStyle="body-label">
                        From
                      </InputLeftAddon>
                      <Input
                        variant="subtle"
                        id="fromDate"
                        textStyle="body-label"
                        type="date"
                        defaultValue={fromStateValue}
                        onChange={() => PageFilters()}
                      />
                    </InputGroup>
                    <InputGroup>
                      <InputLeftAddon textStyle="body-label">To</InputLeftAddon>
                      <Input
                        variant="subtle"
                        id="toDate"
                        textStyle="body-label"
                        type="date"
                        defaultValue={toStateValue}
                        onChange={() => PageFilters()}
                      />
                    </InputGroup>
                  </>
                )}
                <InputGroup>
                  <Input
                    variant="subtle"
                    id="search"
                    type="text"
                    textStyle="body-label"
                    placeholder="Search"
                    defaultValue={searchStateValue}
                    onChange={() => PageFilters()}
                  />
                  <InputRightElement>
                    <img src={SearchIcon} alt="Search Icon" />
                  </InputRightElement>
                </InputGroup>

                <Button
                  textStyle="body-label"
                  minW={isTabletOrSmaller ? "100%" : "100px"}
                  rightIcon={<img src={CloseIcon} alt="Clear Filters" />}
                  onClick={ClearFilters}
                >
                  Clear
                </Button>
              </Stack>
            )}
          </Stack>

          {/* CONTENTS COMPONENT */}
          <Grid
            gap="24px"
            templateColumns={isTabletOrSmaller ? "1fr" : "repeat(6, 1fr)"}
          >
            {pageItems.map((event, index) => {
              const size = index === 3 || index === 4 ? "large" : "small";
              const colSpan = isTabletOrSmaller ? 1 : size === "large" ? 3 : 2;

              return (
                <EventBox
                  key={index}
                  id={event.id}
                  title={event.title}
                  image={event.image}
                  description={event.description}
                  size={size}
                  colSpan={colSpan}
                  address={event.address}
                  city={event.city}
                  date={event.date}
                  startTime={event.startTime}
                  endTime={event.endTime}
                  hyperlink={event.hyperlink}
                  bookingLink={event.bookingLink}
                  repeatType={event.repeatType}
                  productTypeName={event.productTypeName}
                />
              );
            })}

            <GridItem colSpan={isTabletOrSmaller ? 1 : 6}>
              {/* PAGINATION COMPONENT */}
              <Stack
                direction="row"
                justifyContent={isTabletOrSmaller ? "center" : "end"}
              >
                <Button
                  onClick={() => decrementPage()}
                  isDisabled={pageIndex === 0}
                >
                  <img
                    src={ArrowIcon}
                    className="flip-image"
                    alt="Arrow Icon"
                    width="18px"
                  />
                </Button>

                {Array.from(Array(pageCount).keys()).map((index) => {
                  return (
                    <Box
                      key={index}
                      textStyle="body-regular"
                      minW="40px"
                      textAlign="center"
                      alignContent="center"
                      className={`${
                        pageIndex === index ? "page-index-active" : ""
                      }`}
                    >
                      {index + 1}
                    </Box>
                  );
                })}

                <Button
                  onClick={() => incrementPage()}
                  isDisabled={pageIndex >= pageCount - 1}
                >
                  <img src={ArrowIcon} alt="Arrow Icon" width="18px" />
                </Button>
              </Stack>
            </GridItem>
          </Grid>
        </Stack>
      )}
    </>
  );
}
